import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';
import { environment } from "../../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http : HttpClient) { }

  getAllPrivileges() {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/allprivileges',{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  getAllTravellerPrivileges() {
      
    let httpParam : HttpParams=new HttpParams();
   

    return this.http.get( environment.API_URL + '/api/allbusinessprivileges',{ observe : "body", params : httpParam,responseType : "json"})
    
  }
  saveTravellerRole( role:{roleName:any,description:any,privileges:any}){
   
    let httpParam : HttpParams=new HttpParams();
  
  
     return this.http.post(environment.API_URL+ "/api/crm/business-role",role,{observe:"response"})
  
 }
 getAllTravellerRoles(pageinfo : {strpage:any; size:any}, searchField: { searchText: string | number | boolean; roleId: string | number | boolean; }) {
      
  let httpParam : HttpParams=new HttpParams();
  httpParam=httpParam.append("page", pageinfo.strpage);
  httpParam=httpParam.append("size",pageinfo.size);
  httpParam=httpParam.append("searchText", searchField.searchText);
 
  httpParam=httpParam.append("searchRoleId", searchField.roleId);
  //header.append('Content-Type','application/json');

  return this.http.get( environment.API_URL + '/api/crm/business-roles',{ observe : "body", params : httpParam,responseType : "json"})
  
}
getRoleTravellerbyId(id:any){
  let httpParam : HttpParams=new HttpParams();
  httpParam=httpParam.append("roleId", id);
 

  return this.http.get( environment.API_URL + '/api/crm/business-role',{ observe : "body", params : httpParam,responseType : "json"})
  
}
  saveRole( role:{roleName:any,description:any,privileges:any}){
   
    let httpParam : HttpParams=new HttpParams();
  
  
     return this.http.post(environment.API_URL+ "/api/crm/role",role,{observe:"response"})
  
 }
 getAllRoles(pageinfo : {strpage:any; size:any}, searchField: { searchText: string | number | boolean; roleId: string | number | boolean; }) {
      
  let httpParam : HttpParams=new HttpParams();
  httpParam=httpParam.append("page", pageinfo.strpage);
  httpParam=httpParam.append("size",pageinfo.size);
  httpParam=httpParam.append("searchText", searchField.searchText);
 
  httpParam=httpParam.append("searchRoleId", searchField.roleId);
  //header.append('Content-Type','application/json');

  return this.http.get( environment.API_URL + '/api/crm/roles',{ observe : "body", params : httpParam,responseType : "json"})
  
}
getRolebyId(id:any){
  let httpParam : HttpParams=new HttpParams();
  httpParam=httpParam.append("roleId", id);
 

  return this.http.get( environment.API_URL + '/api/crm/role',{ observe : "body", params : httpParam,responseType : "json"})
  
}
}
